/* eslint no-shadow: ["error", { "allow": ["state"] }] */

import findIndex from 'lodash/findIndex'
import groupBy from 'lodash/groupBy'
import keyBy from 'lodash/keyBy'
import reject from 'lodash/reject'
import Vue from 'vue'

import { FETCH_WORKS } from '../../actions.type'
import {
  CREATE_WORK,
  REMOVE_WORK,
  SET_WORK_ALL_REQUEST,
  SET_WORK_ALL_VALUE,
  UPDATE_WORK
} from '../../mutations.type'

const state = {
  all: {
    request: {
      isLoading: undefined,
      isSuccess: undefined,
      isError: undefined,
      isFatalError: undefined,
      delay: undefined,
      lastRequestTime: undefined
    },
    value: []
  }
}

const getters = {
  workAllValue: (state) => state.all.value,
  workAllRequest: (state) => state.all.request,
  workAllById: (state) => keyBy(state.all.value, 'id'),
  workAllByGroupId: (state) => groupBy(state.all.value, 'workGroup.id')
}

const actions = {
  async [FETCH_WORKS]({ commit, state }, params) {
    if (
      (state.all.request.isSuccess && !params?.isReload) ||
      state.all.request.isLoading ||
      state.all.request.isError
    ) {
      return
    }
    try {
      const { data } = await Vue.axios.get('work', {
        'axios-retry': {
          beforeTry: () => {
            commit(SET_WORK_ALL_REQUEST, {
              isLoading: true,
              isError: false
            })
          },
          afterTry: ({ delay, lastRequestTime }) => {
            commit(SET_WORK_ALL_REQUEST, {
              isLoading: false,
              isError: true,
              delay,
              lastRequestTime
            })
          }
        }
      })
      commit(SET_WORK_ALL_REQUEST, {
        isLoading: false,
        isSuccess: true
      })
      commit(SET_WORK_ALL_VALUE, data)
    } catch (e) {
      commit(SET_WORK_ALL_REQUEST, {
        isFatalError: true,
        isLoading: false
      })
    }
  },

  async SOCKET_CREATE_WORK({ commit }, value) {
    commit(CREATE_WORK, value)
  },

  async SOCKET_UPDATE_WORK({ commit }, value) {
    commit(UPDATE_WORK, value)
  },

  async SOCKET_REMOVE_WORK({ commit }, id) {
    commit(REMOVE_WORK, id)
  }
}

const mutations = {
  [SET_WORK_ALL_REQUEST](state, request) {
    state.all.request = {
      ...state.all.request,
      ...request
    }
  },
  [SET_WORK_ALL_VALUE](state, works) {
    state.all.value = works
  },
  [UPDATE_WORK](state, updatedWork) {
    state.all.value.splice(
      findIndex(state.all.value, { id: updatedWork.id }),
      1,
      updatedWork
    )
  },
  [CREATE_WORK](state, createdWork) {
    state.all.value.push(createdWork)
  },
  [REMOVE_WORK](state, id) {
    state.all.value = reject(state.all.value, { id })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
